'use client';

import { Box, freddyTheme, Typography } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';
import { getCommunityTranslationKey } from '@utils/businessUtils/getCommunityTranslationKey';

const NotPartOfCommunityAlert = ({
  closedCommunityType,
  isNotAvailable = false
}: {
  closedCommunityType: string;
  isNotAvailable?: boolean;
}) => {
  const { t } = useTranslation('webshop.business.communities');

  const communityTypeLabel = t(getCommunityTranslationKey(closedCommunityType));

  return (
    <Box
      p={300}
      sx={{
        backgroundColor: isNotAvailable
          ? freddyTheme.color.background.sentimentWarningSubtle
          : freddyTheme.color.background.secondary,
        border: `${freddyTheme.borderWidth[25]} solid ${isNotAvailable ? freddyTheme.color.border.sentimentWarning : freddyTheme.color.border.secondary}`,
        borderRadius: freddyTheme.borderRadius[100]
      }}
    >
      <Typography fontWeight={isNotAvailable ? 'bold' : undefined}>
        {t('notPartOfYourCommunity', { communityType: communityTypeLabel })}
      </Typography>
      {isNotAvailable && (
        <Typography mt={100}>
          {t('productUnavailableExplanation', { communityType: communityTypeLabel })}
        </Typography>
      )}
    </Box>
  );
};

export default NotPartOfCommunityAlert;
